( function () {
	const sliders = document.querySelectorAll( '.starter-services' );

	sliders.forEach( ( wrapper ) => {
		const track      = wrapper.querySelector( '.svc-track' );
		const dots       = wrapper.querySelectorAll( '.svc-dot' );
		const autoplayMs = 5000;

		if ( ! track ) return;

		const originalItems = Array.from( track.querySelectorAll( '.svc-slide' ) );
		const total = originalItems.length;
		if ( total < 2 ) return;

		const getVisible = () => {
			const configured = parseInt( track.dataset.cols || 3, 10 );
			if ( window.innerWidth <= 480 ) return 1;
			if ( window.innerWidth <= 768 ) return Math.min( 2, configured );
			return configured;
		};

		let visible  = getVisible();
		let current  = visible;
		let isAnimating = false;
		let clonesBefore = [];
		let clonesAfter  = [];

		const updateWidth = () => {
			track.style.setProperty( '--svc-slide-width', `${ 100 / visible }%` );
		};

		const buildClones = () => {
			clonesBefore.forEach( c => c.remove() );
			clonesAfter.forEach( c => c.remove() );

			clonesBefore = originalItems.slice( -visible ).map( el => {
				const c = el.cloneNode( true );
				c.setAttribute( 'aria-hidden', 'true' );
				c.classList.add( 'is-clone' );
				return c;
			} );
			clonesAfter = originalItems.slice( 0, visible ).map( el => {
				const c = el.cloneNode( true );
				c.setAttribute( 'aria-hidden', 'true' );
				c.classList.add( 'is-clone' );
				return c;
			} );

			const firstChild = track.firstChild;
			clonesBefore.forEach( c => track.insertBefore( c, firstChild ) );
			clonesAfter.forEach( c => track.appendChild( c ) );
		};

		const getItemWidth = () => {
			const allItems = track.querySelectorAll( '.svc-slide' );
			return allItems[0] ? allItems[0].offsetWidth : 0;
		};

		const setPosition = ( index, animate ) => {
			track.style.transition = animate ? 'transform 0.5s ease' : 'none';
			track.style.transform  = `translateX(-${ index * getItemWidth() }px)`;
		};

		const updateDots = () => {
			const realIndex = ( ( current - visible ) % total + total ) % total;
			dots.forEach( ( dot, i ) => {
				dot.classList.toggle( 'is-active', i === realIndex );
			} );
		};

		const init = () => {
			visible = getVisible();
			current = visible;
			updateWidth();
			buildClones();
			requestAnimationFrame( () => {
				setPosition( current, false );
				updateDots();
			} );
		};

		const goTo = ( index, animate = true ) => {
			if ( isAnimating ) return;
			isAnimating = true;
			current = index;
			setPosition( current, animate );
		};

		track.addEventListener( 'transitionend', () => {
			if ( current >= total + visible ) {
				current = visible;
				setPosition( current, false );
			} else if ( current < visible ) {
				current = total + visible - 1;
				setPosition( current, false );
			}
			updateDots();
			isAnimating = false;
		} );

		const next = () => goTo( current + 1 );
		const prev = () => goTo( current - 1 );

		dots.forEach( ( dot ) => {
			dot.addEventListener( 'click', () => {
				const index = parseInt( dot.dataset.index, 10 ) + visible;
				if ( index === current ) return;
				goTo( index );
				resetTimer();
			} );
		} );

		// Drag / swipe
		let isDown = false;
		let startX = 0;
		let moveX  = 0;

		const dragStart = ( clientX ) => {
			isDown = true;
			startX = clientX;
			track.style.transition = 'none';
			track.style.cursor = 'grabbing';
		};

		const dragMove = ( clientX ) => {
			if ( ! isDown ) return;
			moveX = clientX - startX;
			const currOffset = current * getItemWidth();
			track.style.transform = `translateX(-${ currOffset - moveX }px)`;
		};

		const dragEnd = () => {
			if ( ! isDown ) return;
			isDown = false;
			track.style.cursor = '';
			if ( Math.abs( moveX ) > 50 ) {
				moveX > 0 ? prev() : next();
				resetTimer();
			} else {
				setPosition( current, true );
			}
			moveX = 0;
		};

		track.addEventListener( 'mousedown', ( e ) => dragStart( e.clientX ) );
		window.addEventListener( 'mousemove', ( e ) => dragMove( e.clientX ) );
		window.addEventListener( 'mouseup', dragEnd );

		track.addEventListener( 'touchstart', ( e ) => {
			const touch = e.touches[0];
			if ( touch ) dragStart( touch.clientX );
		}, { passive: true } );

		window.addEventListener( 'touchmove', ( e ) => {
			const touch = e.touches[0];
			if ( touch ) dragMove( touch.clientX );
		}, { passive: true } );

		window.addEventListener( 'touchend', dragEnd, { passive: true } );

		track.querySelectorAll( 'img' ).forEach( img => {
			img.addEventListener( 'dragstart', ( e ) => e.preventDefault() );
		} );

		// Autoplay
		let timer = setInterval( next, autoplayMs );
		const resetTimer = () => { clearInterval( timer ); timer = setInterval( next, autoplayMs ); };

		wrapper.addEventListener( 'mouseenter', () => clearInterval( timer ) );
		wrapper.addEventListener( 'mouseleave', () => { timer = setInterval( next, autoplayMs ); } );

		// Responsive
		let resizeTimer;
		window.addEventListener( 'resize', () => {
			clearTimeout( resizeTimer );
			resizeTimer = setTimeout( () => {
				clearInterval( timer );
				init();
				timer = setInterval( next, autoplayMs );
			}, 200 );
		} );

		init();
	} );
} )();
